import { useState } from "react";
import { useLocation } from "react-router-dom";
import { BannerInstalarFichaje } from "@/components/fichaje/worker/BannerInstalarFichaje";
import { BannerInstalarGeneral } from "@/components/pwa/BannerInstalarGeneral";
import { isIOS, isMovil, useAvisoInstalacion, useConsentido } from "@/components/pwa/useInstallPrompt";

const CLAVE = { general: "pwa-install-dismissed", fichaje: "pwa-install-dismissed-fichaje" };

export default function InstallPrompt() {
  const { pathname } = useLocation();
  const variante = pathname === "/app" || pathname.startsWith("/app/") ? "fichaje" : "general";
  const { deferred, instalada, instalar } = useAvisoInstalacion();
  const consentido = useConsentido();
  const [cerrados, setCerrados] = useState(() => ({
    general: localStorage.getItem(CLAVE.general) === "1",
    fichaje: localStorage.getItem(CLAVE.fichaje) === "1",
  }));

  const ios = isIOS();
  const permitido = variante === "general" || (isMovil() && consentido);
  const disponible = ios || deferred?.v === variante;
  if (instalada || cerrados[variante] || !permitido || !disponible) return null;

  const cerrar = () => {
    localStorage.setItem(CLAVE[variante], "1");
    setCerrados((c) => ({ ...c, [variante]: true }));
  };

  if (variante === "fichaje") return <BannerInstalarFichaje ios={ios} onInstalar={instalar} onCerrar={cerrar} />;
  return <BannerInstalarGeneral ios={ios} onInstalar={instalar} onCerrar={cerrar} />;
}
